import React from 'react';
import { formatCurrency } from '../../lib/helpers/formatters';

const TotalTr = ({ totals = {} }) => {
  const {
    shareToInvoiceTotals = 0,
    panoramicaShareTotals = 0,
    adminShareTotals = 0,
    netTotals = 0,
    grossTotals = 0,
  } = totals;

  return (
    <tr className="summary-tr">
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td className="txt-table-right">{formatCurrency(grossTotals)}</td>
      <td className="txt-table-right">{formatCurrency(netTotals)}</td>
      <td className="txt-table-right">
        {formatCurrency(shareToInvoiceTotals)}
      </td>
      <td>-</td>
      <td className="txt-table-right">
        {formatCurrency(panoramicaShareTotals)}
      </td>
      <td className="txt-table-right">{formatCurrency(adminShareTotals)}</td>
    </tr>
  );
};

export default TotalTr;
